import React, { useState } from 'react';
import ProtectedComponent from 'hoc/ProtectedComponent';
import PropTypes from 'prop-types';
import ReactQuill from 'react-quill';
import styled from 'styled-components';
import { get } from 'lodash';
import moment from 'moment';
import EditNoteContainer from 'containers/forms/EditNoteContainer';
import DeleteIconButton from 'components/molecules/buttons/DeleteNoteButton';
import EditIconButton from 'components/molecules/buttons/EditNoteButton';
import { ANNOTATION_UPDATE } from 'constants/capabilities';

const ViewNoteWrapper = styled.div`
    display: flex;
    align-items: flex-start;
    width: 100%;
    position: relative;
    font-size: 14px;
    border: 1px solid ${props => props.theme.colors.primary}; 
    background-color: #F5F9FD;
    padding: 12px;
    margin-bottom: 16px;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.20);    
`;

const IconWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    flex: initial;
    width: 80px;

    i:nth-child(1){
        margin-right: 8px;
    }
`;

const ProtectedIconWrapper = ProtectedComponent({ requiredCapabilities: [ANNOTATION_UPDATE] })(IconWrapper);

const DateWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    width: auto;
    font-weight: bold;
    font-size: 16px;
    color: ${props => props.theme.colors.darkgray};

    span:nth-child(2) {
        margin: 0 5px;
    }
`;

const ReactQuillWrapper = styled.div`
    width: 100%;   
`;

const ViewNoteTile = (props) => {
    const [editToggle, setEditToggle] = useState(false);
    const { note, adminContext, deleteNote } = props;

    const noteMessage = get(note, 'meta.content');
    const entityId = get(note, 'meta.entityId');
    const annotationId = get(note, 'id');
    const startDate = moment(get(note, 'meta.start')).format('MMMM Do, YYYY');
    const endDate = moment(get(note, 'meta.end')).format('MMMM Do, YYYY');

    return editToggle ? (
        <EditNoteContainer
            handleToggle={() => setEditToggle(false)}
            note={note}
            entityId={entityId}
            adminContext={adminContext}
        />
    ) : (
        <React.Fragment>
            <DateWrapper>
                <span>{startDate}</span>
                <span>—</span>
                <span>{endDate}</span>
            </DateWrapper>
            <ViewNoteWrapper>
                <ReactQuillWrapper>
                    <ReactQuill
                        value={noteMessage}
                        readOnly={true}
                        theme={'bubble'}
                    />
                </ReactQuillWrapper>
                <ProtectedIconWrapper>
                    <EditIconButton
                        className="icon-edit"
                        onClick={() => setEditToggle(true)}
                    />
                    <DeleteIconButton
                        className={'icon-trash'}
                        onClick={() => deleteNote({ annotationId, entityId })}
                    />
                </ProtectedIconWrapper>
            </ViewNoteWrapper>
        </React.Fragment>
    );
};

ViewNoteTile.propTypes = {
    note: PropTypes.object.isRequired,
    deleteNote: PropTypes.func.isRequired,
    adminContext: PropTypes.bool
};

export default ViewNoteTile;



// WEBPACK FOOTER //
// ./src/components/molecules/annotations/ViewNoteTile.js